<template>
  <div>
    <chart-list ref="list" @load="load" />
    <chart-composer ref="composer" @updated="updated" @deleted="deleted" />
  </div>
</template>

<script>
import filters from "@/filters";
import ChartComposer from "./OrganizationChartComposer";
import ChartList from "./OrganizationChartList";

export default {
  name: "OrganizationChartIndex",
  components: {
    ChartComposer,
    ChartList
  },
  filters: filters,
  data() {
    return {};
  },
  computed: {},
  methods: {
    load(chart) {
      this.$refs.composer.load(chart);
    },
    updated(chart) {
      this.$refs.list.update(chart);
    },
    deleted(uuid) {
      this.$refs.list.delete(uuid);
    }
  },
  mounted() {},
  watch: {}
};
</script>

<style>
</style>
